import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Row, Col, Pagination } from "react-bootstrap";
import DateRange3 from "../../Component/DateRange/DateRange3";
import { left, right } from "../../assets/img";
import { get, post } from "../../Services/ApiHandler";
import { URLS } from "../../Services/Constant";
import useStoreKv from "../redux/store/useStorekv";
import { useAppContext } from "../../Services/AppContext";
import CustomScroll from "../../Component/CustomScroll";
import ResultCard from "../../Component/ResultCard";
import { MaskIcon } from "../../Component/MaskIcon";

const OverallResult = () => {
  const navigate = useNavigate();
  const { kv, set } = useStoreKv();
  const Results = kv.results || [];
  const [loading, setLoading] = useState(false);
  const [drawDate, setDrawDate] = useState('');
  const [results, setResults] = useState(Results);
  const [pagination, setPagination] = useState({});
  const [currentPage, setCurrentPage] = useState(1);
  const [revokeLoadingId, setRevokeLoadingId] = useState(null);
  const [revokeConfirm, setRevokeConfirm] = useState(null);
  const { arrowEnable } = useAppContext();

  const getList = async () => {
    try {
      setLoading(true);
      const res = await get(`${URLS.OVERALLRESULT}?date=${drawDate}&page=${currentPage}`);
      if (res?.status === "success" && Array.isArray(res.data)) {
        setResults(res.data);
        set('results', res?.data);
        setPagination(res.pagination);
      } else {
        setResults([]);
        setPagination({});
      }
    } catch (error) {
      setResults([]);
      setPagination({});
    } finally {
      setLoading(false);
    }
  };

  const handleRevoke = async () => {
    if (!revokeConfirm) return;
    try {
      setRevokeLoadingId(revokeConfirm.id);
      setRevokeConfirm(null);
      const response = await post(`games/winning/revoke`, { game_slot_id: revokeConfirm.id });
      if (response?.status === "success") {
        getList();
      }
    } catch (error) {
      console.error("Revoke error:", error);
    } finally {
      setRevokeLoadingId(null);
    }
  };

  useEffect(() => {
    getList();
  }, [drawDate, currentPage]);

  useEffect(() => { }, [arrowEnable]);

  return (
    <div className="dashRightView marginScrolls">
      <CustomScroll>
        <div style={{ paddingBottom: 200, paddingTop: 0 }} className="container_overalls col-md-5">

          <div className="my-4 col-md-5">
            <DateRange3 selectedDate={drawDate} setSelectedDate={setDrawDate} />
          </div>

          {results.length === 0 && !loading && (
            <p style={{ textAlign: "center" }} className="f3 fs-sm-14 fs-md-16 fs-lg-18 gray mt-4">
              No results found.
            </p>
          )}

          {results.map((res, idx) => (
            <div className="mt-3 col-md-5" key={idx}>
              <ResultCard
                res={res}
                onRevoke={setRevokeConfirm}
                revokeLoadingId={revokeLoadingId}
              />
            </div>
          ))}

        </div>
      </CustomScroll>

      {/* PAGINATION */}
      <Row style={{ width: !arrowEnable ? '100%' : '' }} className="justify-content-between table-show bg-primary2 mt-4">
        <Col className="d-flex ac-jb pagination_boxs align-items-center">
          <p className="px-1 mb-0 f3 fs-xs-13 fs-md-14">
            Total Pages: <strong>{pagination?.total_pages || 1}</strong>
          </p>
          <Pagination className="gap-1 pointer mb-0 d-flex align-items-center">
            {currentPage > 1 && (
              <MaskIcon  src={left} width={18} alt="Previous"
                onClick={() => setCurrentPage(currentPage - 1)}
                style={{ opacity: currentPage === 1 ? 0.4 : 1, cursor: currentPage === 1 ? "not-allowed" : "pointer" }}
              />
            )}
            <input
              type="number"
              value={currentPage}
              onFocus={(e) => e.target.select()}
              onKeyDown={(e) => { if (e.key === "Backspace") setCurrentPage(""); }}
              onChange={(e) => {
                const val = e.target.value;
                if (val === "") { setCurrentPage(""); return; }
                const num = Number(val);
                const max = pagination?.total_pages || 1;
                if (num >= 1 && num <= max) setCurrentPage(num);
              }}
              onBlur={() => { if (!currentPage || currentPage < 1) setCurrentPage(1); }}
              style={{ width: 25, height: 25, borderRadius: 8, position: "relative", paddingBottom: 2, fontSize: 12, border: "2px solid #8F0D3d", textAlign: "center" }}
              className="placholdercolorchanges2"
            />
            {currentPage < (pagination.total_pages || 1) && (
              <MaskIcon src={right} width={18} alt="Next"
                onClick={() => setCurrentPage(currentPage + 1)}
                style={{ opacity: currentPage === (pagination.total_pages || 1) ? 0.4 : 1, cursor: currentPage === (pagination.total_pages || 1) ? "not-allowed" : "pointer" }}
              />
            )}
          </Pagination>
        </Col>
      </Row>

      {/* ── REVOKE CONFIRM POPUP ── */}
      {revokeConfirm && (
        <div
          onClick={() => setRevokeConfirm(null)}
          style={{
            position: "fixed", inset: 0,
            background: "rgba(0,0,0,0.45)",
            zIndex: 9999,
            display: "flex", alignItems: "center", justifyContent: "center",
            padding: 16,
          }}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            style={{
              background: "#fff",
              borderRadius: 20,
              padding: "32px 28px 24px",
              maxWidth: 380,
              width: "100%",
              textAlign: "center",
              boxShadow: "0 8px 32px rgba(0,0,0,0.18)",
            }}
          >
            <p style={{ fontSize: 17, fontWeight: 600, color: "#1B1B1B", marginBottom: 24, lineHeight: 1.5 }}>
              Are you sure you want to revoke the result for{" "}
              <strong>"{revokeConfirm.lot_name}"</strong> on {revokeConfirm.date}?
            </p>
            <div style={{ display: "flex", gap: 14, justifyContent: "center" }}>
              <button
                onClick={() => setRevokeConfirm(null)}
                style={{
                  flex: 1, height: 48, borderRadius: 50,
                  border: "2px solid #8F0D3D",
                  background: "transparent", color: "#8F0D3D",
                  fontWeight: 700, fontSize: 16, cursor: "pointer",
                }}
              >
                No
              </button>
              <button
                onClick={handleRevoke}
                style={{
                  flex: 1, height: 48, borderRadius: 50,
                  border: "none", background: "#8F0D3D",
                  color: "#fff", fontWeight: 700,
                  fontSize: 16, cursor: "pointer",
                }}
              >
                Yes
              </button>
            </div>
          </div>
        </div>
      )}

    </div>
  );
};

export default OverallResult;